const esc = (v) =>
  String(v ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export function openPackingSlip(order) {
  if (!order) return;
  const c = order.customer || {};
  const isPickup = order.fulfillment === "pickup";
  const dateStr = (order.created_at || "").slice(0, 10);
  const shortId = (order.id || "").slice(0, 8).toUpperCase();
  const items = order.items || [];
  const totalUnits = items.reduce((s, i) => s + (i.quantity || 0), 0);

  const rows = items
    .map(
      (li) => `
      <tr>
        <td class="pick">&#9744;</td>
        <td class="qty">${esc(li.quantity)}</td>
        <td class="inv">${li.inv_number ? esc(li.inv_number) : "<span class='muted'>—</span>"}</td>
        <td>
          <div class="name">${esc(li.name)}</div>
          <div class="sub">SKU ${esc(li.sku || "—")}${li.condition ? " &middot; " + esc(li.condition) : ""}</div>
        </td>
      </tr>`
    )
    .join("");

  const shipBlock = isPickup
    ? `<div class="badge">LOCAL PICKUP</div>
       <div class="addr"><strong>${esc(c.name)}</strong><br/>${esc(c.email)}${c.phone ? "<br/>" + esc(c.phone) : ""}</div>`
    : `<div class="label">SHIP TO</div>
       <div class="addr">
         <strong>${esc(c.name)}</strong><br/>
         ${esc(c.address)}<br/>
         ${esc(c.city)}${c.city ? ", " : ""}${esc(c.state)} ${esc(c.zip)}
         ${c.phone ? "<br/>" + esc(c.phone) : ""}
       </div>`;

  const tracking = order.tracking_number
    ? `<div class="track"><span class="label">TRACKING (${esc(order.carrier || "UPS")})</span> <strong>${esc(order.tracking_number)}</strong></div>`
    : "";

  const html = `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>Pick &amp; Ship Slip · ${esc(shortId)}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: "Helvetica Neue", Arial, sans-serif; color: #111; margin: 0; padding: 28px 32px; }
  .top { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #111; padding-bottom: 14px; }
  .brand { font-weight: 900; font-size: 22px; letter-spacing: -0.5px; }
  .brand small { display: block; font-weight: 400; font-size: 9px; letter-spacing: 3px; text-transform: uppercase; color: #666; margin-top: 2px; }
  .doctype { text-align: right; }
  .doctype .t { font-weight: 800; font-size: 15px; text-transform: uppercase; letter-spacing: 1px; }
  .doctype .m { font-size: 11px; color: #444; margin-top: 4px; font-family: monospace; }
  .meta { display: flex; gap: 40px; margin: 20px 0 8px; }
  .label { font-size: 9px; letter-spacing: 2px; text-transform: uppercase; color: #777; margin-bottom: 4px; }
  .addr { font-size: 13px; line-height: 1.5; }
  .badge { display: inline-block; background: #111; color: #fff; font-weight: 800; font-size: 12px; letter-spacing: 1px; padding: 4px 10px; text-transform: uppercase; margin-bottom: 8px; }
  table { width: 100%; border-collapse: collapse; margin-top: 18px; }
  thead th { background: #111; color: #fff; text-transform: uppercase; font-size: 10px; letter-spacing: 1px; text-align: left; padding: 8px 10px; }
  tbody td { border-bottom: 1px solid #ddd; padding: 10px; vertical-align: top; font-size: 13px; }
  .pick { width: 34px; font-size: 20px; text-align: center; }
  .qty { width: 40px; font-weight: 800; }
  .inv { width: 110px; font-weight: 900; font-size: 18px; font-family: monospace; }
  .name { font-weight: 700; }
  .sub { font-size: 11px; color: #666; margin-top: 2px; font-family: monospace; }
  .muted { color: #bbb; }
  .foot { display: flex; justify-content: space-between; margin-top: 22px; align-items: flex-end; }
  .track { font-size: 13px; }
  .track .label { display: block; }
  .units { font-size: 12px; color: #444; }
  .sign { margin-top: 40px; border-top: 1px solid #111; padding-top: 6px; font-size: 10px; letter-spacing: 1px; text-transform: uppercase; color: #777; width: 260px; }
  @media print { body { padding: 0; } @page { margin: 16mm; } }
</style>
</head>
<body>
  <div class="top">
    <div class="brand">STR SURPLUS<small>Operator Liquidation &middot; Fort Lauderdale, FL</small></div>
    <div class="doctype">
      <div class="t">Pick &amp; Ship Slip</div>
      <div class="m">Order #${esc(shortId)}</div>
      <div class="m">${esc(dateStr)}</div>
    </div>
  </div>

  <div class="meta">
    <div>${shipBlock}</div>
    <div>
      <div class="label">Fulfillment</div>
      <div class="addr">${isPickup ? "Local Pickup" : "UPS Ground Shipping"}</div>
    </div>
  </div>

  <table>
    <thead>
      <tr><th>Pick</th><th>Qty</th><th>Inv#</th><th>Item</th></tr>
    </thead>
    <tbody>${rows}</tbody>
  </table>

  <div class="foot">
    <div>
      <div class="units">${items.length} line${items.length === 1 ? "" : "s"} &middot; ${totalUnits} unit${totalUnits === 1 ? "" : "s"} total</div>
      ${tracking}
    </div>
    <div style="text-align:right">
      <div class="label">Order Total</div>
      <div style="font-weight:800;font-size:16px">${money(order.total)}</div>
    </div>
  </div>

  <div class="sign">Picked by ______________  Date __________</div>

  <script>window.onload = function(){ window.focus(); window.print(); };</script>
</body>
</html>`;

  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
